import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

const BASE_URL = environment.application === 'DEVELOPMENT' ?
  environment.baseUrl :
  '';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith('/corporate-client')) {
    const apiReq = req.clone({ url: BASE_URL + req.url });
    return next(apiReq);
  }
  // Всё остальное (например, /i18n/...) — не меняем!
  return next(req);
};